(function () {

    'use strict';

    /*global $:true */

    let cologicStorageService = {



        addItemToLocalStorage: function(_key, _value, _add = true){
            let oldValue = JSON.parse(localStorage.getItem(_key));
            let addValue = _value.toString();
            let newValue;
            if(oldValue != null){
                let valueArray;
                if(addValue.indexOf(',') !== -1){
                   addValue.split(',').forEach(function(_entry){

                    if(oldValue.toString().indexOf(',') !== -1) {
                        valueArray = oldValue.split(',');
                    }else{
                        valueArray = [oldValue];
                    }
                    if(!valueArray.includes(_entry)){
                        newValue = oldValue + ',' + _entry
                    }
                   });

                }else {
                    if(oldValue.toString().indexOf(',') !== -1) {
                        valueArray = oldValue.split(',');
                    }else{
                        valueArray = [oldValue];
                    }
                    if(valueArray.includes(addValue)){
                        return false;
                    }else{
                        newValue = oldValue + ',' + addValue
                    }
                }
            }else {
                newValue = addValue
            }
            localStorage.setItem(_key, JSON.stringify(newValue));
        },

        removeItemFromLocalStorage: function(_key, _value){
            if(getLocalStorage(_key)) {
                let newList = getLocalStorage(_key).split(',');
                newList = newList.filter(function(e) { return e != _value });
                newList = newList.join();
                // console.log(newList);
                if(newList == ''){
                    localStorage.removeItem(_key);
                }else{
                    window.localStorage.removeItem(_key);
                    localStorage.setItem(_key, JSON.stringify(newList));
                }
            }
        },

        setCompleteLocalStorage: function(_key, _value){
            localStorage.setItem(_key, JSON.stringify(_value));
        },
        unsetCompleteLocalStorage: function(_key){
            localStorage.removeItem(_key);
        },

        getLocalStorage: function(_key){
            // console.log(JSON.parse(localStorage.getItem(_key)));
            return JSON.parse(localStorage.getItem(_key));
        },

        getLocalStorageListLength: function(_key){
            let _values = JSON.parse(localStorage.getItem(_key));
            let valueArray = [];
            if(_values != null && _values != ''){
                if(_values.toString().indexOf(',') !== -1) {
                    valueArray = _values.split(',');
                }else{
                    valueArray = [_values];
                }
                return valueArray.length;
            } else{
                return false;
            }
        },



};

    //------------------------------------

    //gemeinsam verfügbar machen
    if (typeof (cologic) === 'undefined')
        window.cologic = {};
    $.extend(cologic, cologicStorageService);
}());